<template>
    <div class="page-content">
        <div id="terms" class="section grow pt-5 pb-5 bg-eggshell">
            <div class="container h-100">
                <div class="d-flex h-100 text-left align-items-center">
                    <div class="w-100">
                        <termly-policy termlyDataId="e9fd64b6-a858-45a5-af79-dbeb8b212767"></termly-policy>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'terms',
  metaInfo: {
      title: 'Terms of Use'
  },
  components: {
  },
  mounted(){
  }
}
</script>
